export interface Contact {
  id: string;
  dossier_id: string;
  civilite?: "M." | "Mme" | "Mlle";
  nom: string;
  prenom?: string;
  phone?: string;
  email?: string;
  role?: string;
  is_primary: boolean;
  pays?: string;
  /** Une ligne, pour tout ce qui l'affiche ; composée à partir des trois champs ci-dessous. */
  adresse?: string;
  /** Structurée comme la fiche client Alpha (Adresse / Code postal / Localité) : ce que le
   *  transfert ServiceBox envoie quand c'est renseigné. */
  adresse_rue?: string;
  code_postal?: string;
  ville?: string;
  /** Alpha DMS client id (CLIENT_DMS_ID), captured on ServiceBox transfer. Links the
   *  Carvis contact to its DMS counterpart so we can update it rather than duplicate. */
  dms_id?: string;
  created_at: string;
}

/** Un client a UN contact principal, jamais deux, jamais zéro. `preferredId` = celui qu'on
 *  vient de désigner (il l'emporte sur tous les autres) ; sans lui, le premier déjà
 *  principal reste, et s'il n'y en a aucun le premier contact le devient. */
export function withSinglePrimary<T extends Pick<Contact, "id" | "is_primary">>(contacts: T[], preferredId?: string): T[] {
  if (contacts.length === 0) return contacts;
  const keepId = preferredId && contacts.some((c) => c.id === preferredId)
    ? preferredId
    : (contacts.find((c) => c.is_primary) || contacts[0]).id;
  return contacts.map((c) => (c.is_primary === (c.id === keepId) ? c : { ...c, is_primary: c.id === keepId }));
}
